namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter])
    export class ApproveFgFormatter implements Slick.Formatter {
        static format(ctx: Slick.FormatterContext) {
            let item = ctx.item as PoApprovalTranRow;

            let klass = '';
            if (item.ApproveFg == ApproveFgonApptran.inprotrigger) {
                klass = 'danger'
                return `<span class="label label-${klass}">ยกเลิก</span>`;
            } else if (item.ApproveFg == ApproveFgonApptran.Posted) {
                klass = 'success'
                return `<span class="label label-${klass}">อนุมัติแล้ว</span>`;
            } else if (item.ApproveFg == ApproveFgonApptran.inpro) {
                klass = 'info'
                return `<span class="label label-${klass}">ส่งกลับแก้ไข</span>`;
            } else  {
                klass = 'info'
                return `<span class="label label-${klass}">รออนุมัติ</span>`;
            }

                    //${OrderStatus[item.OrderStatus]}
        }

        format(ctx: Slick.FormatterContext) {
            return ApproveFgFormatter.format(ctx);
        }

    }
}